import { formatThroughput } from "../format";

/**
 * Rail panel summarizing the last completed run: wall-clock,
 * cumulative throughput, and which engine executed it.
 */
export function LastRunPanel({
  elapsedMs,
  nSpins,
  engineLabel,
}: {
  elapsedMs: number;
  nSpins: number;
  engineLabel: string;
}) {
  const rows: Array<[string, string]> = [
    ["wall", `${Math.round(elapsedMs).toLocaleString()} ms`],
    ["throughput", formatThroughput(nSpins / (elapsedMs / 1000))],
    ["engine", engineLabel],
  ];
  return (
    <div className="border border-paper-border p-3 dark:border-term-border">
      <div className="mb-2 text-[11px] font-semibold uppercase tracking-widest text-paper-bright dark:text-term-bright">
        Last run
      </div>
      <dl className="space-y-1">
        {rows.map(([k, v]) => (
          <div key={k} className="flex justify-between text-xs">
            <dt className="text-paper-label dark:text-term-label">{k}</dt>
            <dd className="tabular-nums text-paper-text dark:text-term-text">
              {v}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
